import { type GenericMap } from "@client/types";
import { identity } from "lodash";
import React from "react";

export type Listener = {
  getValue: () => Promise<GenericMap<any>>;
  validate: () => Promise<string | null>;
};

export interface ContextProps {
  listeners: Listener[];
  subscribeOnSubmit: (listener: Listener) => void;
  unsubscribeOnSubmit: (listener: Listener) => void;
}

export const Context = React.createContext<ContextProps>({
  listeners: [],
  subscribeOnSubmit: identity,
  unsubscribeOnSubmit: identity
});
